import { createSlice } from "@reduxjs/toolkit";
import {
  createOrganization,
  deleteOrganization,
  fetchOrganizations,
  fetchOrganizationUsersById,
  updateOrganization,
} from "./organizations.actions";
import { DEFAULT_LIMIT, EMPTY_STRING, INDEX } from "../../constants";
const { SECOND } = INDEX;

const searchFilter = {
  name: EMPTY_STRING,
  page: SECOND,
  limit: DEFAULT_LIMIT,
  subscriptionType: EMPTY_STRING,
};

const initialState = {
  organizations: {
    data: [],
  },
  selectOrganizationUsers: [],
  selectedOrganizationId: null,
  selectedOrganization: null,
  organizationsFilters: searchFilter,
  organizationUsersFilters: searchFilter,
  organizationUsersId: null,
};

const slice = createSlice({
  name: "organizations",
  initialState,
  reducers: {
    setSelectedOrganizationId(state, action) {
      state.selectedOrganizationId = action.payload;
    },
    setSelectedOrganization(state, action) {
      state.selectedOrganization = action.payload;
    },
    setOrganizationsFilters(state, action) {
      state.organizationsFilters = action.payload || searchFilter;
    },
    setOrganizationUsersFilters(state, action) {
      state.organizationUsersFilters = action.payload || searchFilter;
    },
    setOrganizationUsersId(state, action) {
      state.organizationUsersId = action.payload;
    },
    setOrganizationUsers(state, action) {
      state.selectOrganizationUsers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizations.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.organizations = action.payload || state.organizations;
      })
      .addCase(updateOrganization.fulfilled, (state, action) => {
        if (!action.payload) return;
        const updatedOrganizations = state.organizations.data.map(
          (organization) =>
            organization.id === action.payload.id
              ? { ...organization, ...action.payload }
              : organization
        );
        state.organizations = {
          ...state.organizations,
          data: updatedOrganizations,
        };
        state.selectedOrganization = action.payload;
      })
      .addCase(fetchOrganizationUsersById.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.selectOrganizationUsers = action.payload;
      })
      .addCase(deleteOrganization.fulfilled, (state, action) => {
        if (!action.payload) return;
        const updatedOrganizations = state.organizations.data.filter(
          (item) => item.id !== action.payload.id
        );
        state.organizations = {
          ...state.organizations,
          data: updatedOrganizations,
        };
      })
      .addCase(createOrganization.fulfilled, (state, action) => {
        if (!action.payload) return;
        state.organizations = {
          ...state.organizations,
          total: state.organizations.total + 1,
          count: state.organizations.count + 1,
          data: [...state.organizations.data, action.payload],
        };
      });
  },
});
export default slice;

export const { name, actions, reducer } = slice;
